// extracted by mini-css-extract-plugin
export default {"modalouter":"Query_modalouter__OsGO0","buttonsection":"Query_buttonsection__uflZG"};